module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _c('strong', [_vm._v("Also by Thom Hartmann")])]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging"
  }, [_c('em', [_vm._v("Unequal Protection: How Corporations Became “People”—and How You Can Fight Back")])]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging1"
  }, [_c('em', [_vm._v("Threshold: The Crisis of Western Culture")])]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging1"
  }, [_c('em', [_vm._v("Cracking the Code: How to Win Hearts, Change Minds, and Restore America’s Original Vision")])]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging1"
  }, [_c('em', [_vm._v("Screwed: The Undeclared War against the Middle Class—and What We Can Do about It")])]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging1"
  }, [_c('em', [_vm._v("What Would Jefferson Do?: A Return to Democracy")])]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging1"
  }, [_c('em', [_vm._v("The Last Hours of Ancient Sunlight: The Fate of the World and What We Can Do Before It’s Too Late")])]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging1"
  }, [_c('em', [_vm._v("Ultimate Sacrifice: John and Robert Kennedy, the Plan for a Coup in Cuba, and the Murder of JFK")])]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging1"
  }, [_c('em', [_vm._v("Legacy of Secrecy: The Long Shadow of the JFK Assassination")])]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging1"
  }, [_c('em', [_vm._v("We the People: A Call to Take Back America")])]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging1"
  }, [_c('em', [_vm._v("Walking Your Blues Away: How to Heal the Mind and Create Emotional Well-being")])]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging1"
  }, [_c('em', [_vm._v("Attention Deficit Disorder : A Different Perception")])]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging1"
  }, [_c('em', [_vm._v("Thom Hartmann’s Complete Guide to ADHD: Help for Your Family at Home, School and Work")])]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging1"
  }, [_c('em', [_vm._v("Healing ADD : Simple Exercises That Will Change Your Daily Life")])]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging1"
  }, [_c('em', [_vm._v("The Edison Gene: ADHD and the Gift of the Hunter Child")])]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging1"
  }, [_c('em', [_vm._v("ADD Success Stories: A Guide to Fulfillment for Families with Attention Deficit Disorder")])]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging1"
  }, [_c('em', [_vm._v("Think Fast: The ADD Experience")])]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging1"
  }, [_c('em', [_vm._v("Beyond ADD: Hunting for Reasons in the Past and Present")])]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging1"
  }, [_c('em', [_vm._v("ADHD Secrets of Success: Coaching Yourself to Fulfillment in the Business World")])]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging1"
  }, [_c('em', [_vm._v("The Prophet’s Way: A Guide to Living in the Now")])]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging1"
  }, [_c('em', [_vm._v("The Greatest Spiritual Secret of the Century")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4053db4a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/also.vue
// module id = 63
// module chunks = 0